import React from "react";
import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { PageBreak } from "../core/pdf/types";

export function PageBreakEditor(props: {
	pb: PageBreak,
}) {
	const designer = useDesigner();

	const elementContext = useElementContext(props.pb);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	const contentStyle = {
		// borderTop: "solid black 1px",
		// borderBottom: "solid black 1px",
		backgroundColor: "#999",
		color: "#fff",
		textAlign: "center",
	} as any;

	return (
		<ElementContext.Provider value={elementContext}>
			<div
				className={"pagebreak-editor content-element flex align-start " + state.classes}
				data-key={props.pb.id}
				id={state.elementID}
				tabIndex={0}
			>
				<div style={contentStyle} className="width-100pc">
					PAGE BREAK
				</div>
			</div>
		</ElementContext.Provider>
	)
}